import PageHero from "@/components/layout/PageHero";
import SimulatorPanel from "@/components/simulator/SimulatorPanel";
import CTA from "@/components/sections/CTA";
import { IMAGES } from "@/lib/constants";

export default function SimulatorPage() {
    return (
        <div data-testid="page-simulator">
            <PageHero
                title={<>Model reduction targets. <em className="text-gold not-italic font-light">See risk & rupees move</em> in real time.</>}
                lead="Adjust Scope 1, 2, and 3 targets. Watch composite risk drop, CBAM exposure shrink, and cost-of-capital uplift reverse — for MSMEs, banks, or an entire regulated sector."
                image={IMAGES.dashboard}
            />
            <section className="relative py-16 lg:py-24 border-t border-navy/10">
                <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
                    <SimulatorPanel />
                </div>
            </section>
            <CTA />
        </div>
    );
}
